// extracted by mini-css-extract-plugin
export default {"Container":"j7qYEhOqww6sOtDM3MQ6","Box1":"mpRLVA7CbcvCmB5OnoYS","Box2":"h9nRNwDYUgncDf4PCTX6","value":"flROISzwXVf2D_ImYTD8","resetButton":"zEy08_YbjX1J9qe6D9rY"};